import React from 'react';
import { components, type ValueContainerProps } from 'react-select';

import DeparturePickerValue from '@lt/components/components/DeparturePickerValue';
import type { DepartureOption } from '@lt/api/dist/types/departure';

export const ValueContainer = ({
  children,
  ...props
}: ValueContainerProps<DepartureOption, false>): JSX.Element => {
  const { getValue, isDisabled } = props;
  const [currentValue] = getValue();

  return (
    <components.ValueContainer {...props}>
      <DeparturePickerValue isDisabled={isDisabled} currentValue={currentValue}>
        {children}
      </DeparturePickerValue>
    </components.ValueContainer>
  );
};
